// extracted by mini-css-extract-plugin
export default {"page":"Portfolio_page__bH0r+","eyebrow":"Portfolio_eyebrow__nJDiO","list":"Portfolio_list__OXo4I","contact":"Portfolio_contact__aWMM6","contactLinks":"Portfolio_contactLinks__RVD8B"};